const NotificationType = {
  NEW_COMPLAINT: 1,
  NEW_COMPLAINT_EVENT: 2,
  NEW_RESPONSE: 3,
  NEW_DSAR: 4,
  NEW_DSAR_EVENT: 5,
  NEW_OMBUDSMAN: 6,
  NEW_OMBUDSMAN_EVENT: 7,
  NEW_MENTIONS: 8,
  NEW_QAS: 9,
  NEW_SUPPORT_TICKET: 10,
  NEW_SUPPORT_MESSAGE: 11,
  NEW_SUPPORT_STATUS: 12,
};

export default NotificationType;
